// extracted by mini-css-extract-plugin
export var arrow = "FreeText-module--arrow--163dd";
export var arrowNo = "FreeText-module--arrow_no--9d5f1";
export var arrowYes = "FreeText-module--arrow_yes--8b590";
export var flex = "FreeText-module--flex--10127";
export var flex1 = "FreeText-module--flex_1--dc891";
export var flexCenter = "FreeText-module--flex_center--1970d";
export var flexCenterCol = "FreeText-module--flex_center_col--b9504";
export var flexCol = "FreeText-module--flex_col--bf8a9";
export var flexFixCenterCol = "FreeText-module--flex_fix_center_col--5f26e";
export var flexFixedCenterCol = "FreeText-module--flex_fixed_center_col--9be06";
export var freeText = "FreeText-module--freeText--75217";
export var rotating = "FreeText-module--rotating--51fbd";